export const locationOptions = [
    {
        title: '北部地區',
        options: [
            '基隆市',
            '臺北市',
            '新北市',
            '桃園市',
            '新竹市',
            '新竹縣',
            '宜蘭縣',
        ],
        model: 'locationN',
    },
    {
        title: '中部地區',
        options: ['苗栗縣', '臺中市', '彰化縣', '南投縣', '雲林縣'],
        model: 'locationM',
    },
    {
        title: '南部地區',
        options: ['嘉義市', '嘉義縣', '台南市', '高雄市', '屏東縣', '宜蘭縣'],
        model: 'locationS',
    },
    {
        title: '東部地區',
        options: ['花蓮縣', '臺東縣'],
        model: 'locationE',
    },
    {
        title: '外島地區',
        options: ['澎湖縣', '金門縣', '連江縣'],
        model: 'locationO',
    },
]

export const peopleCountOptions = [
    '20人以下',
    '20-50人',
    '50-100人',
    '100-200人',
    '200-500人',
    '500-1000人',
    '1000人以上',
]
